module.exports = __webpack_public_path__ + "img/example-wechat-credit-pay02.21b789c6.png";